/* Helpers for prerendered ("saved at publish time") pages.

   scripts/prerender.js renders every page to finished HTML when the site is built. Those pages carry
   the content they were rendered with (window.__PRERENDER_DATA__), so the browser can take over the
   saved page without redrawing it, and then refresh anything that has changed since. */

let hydrating = false;

/* Filled in by src/prerender-entry.js while a page is being rendered at publish time. Unused in the browser. */
export const serverRender = { data: null, seoProps: null, widthSensitive: false };

/* True on the server, and in the browser while it is taking over a saved page. During that first
   render the browser has to produce exactly what was saved. */
export function isHydrating() {
  return typeof window === "undefined" || hydrating;
}

export function startHydration() {
  hydrating = true;
}

/* Shows a page that was held back until its layout was right (see the data-ssr-hold rule in
   public/index.html). While held, transitions are switched off; reading offsetHeight makes the browser
   settle the layout for the real screen width first, so nothing animates from the desktop layout. */
function releaseHold() {
  const root = document.getElementById("root");
  if (!root || !root.hasAttribute("data-ssr-hold")) return;
  void root.offsetHeight;
  root.removeAttribute("data-ssr-hold");
}

/* Called once the browser has taken over a saved page (or is starting fresh). The release waits one
   frame so that the layout for the real screen width, which React applies right after taking over,
   is already in place. The timer covers background tabs, where frames are paused. */
export function hydrationDone() {
  hydrating = false;
  if (typeof document === "undefined") return;
  const root = document.getElementById("root");
  if (!root || !root.hasAttribute("data-ssr-hold")) return;
  if (typeof requestAnimationFrame === "function") requestAnimationFrame(releaseHold);
  setTimeout(releaseHold, 250);
}

/* Content saved with the page, by key: "blogList", "blogPost:<slug>", "galleryCases:<page>".
   Undefined when there is none. */
export function getPrerenderData(key) {
  const store = typeof window === "undefined" ? serverRender.data : window.__PRERENDER_DATA__;
  return store && Object.prototype.hasOwnProperty.call(store, key) ? store[key] : undefined;
}
